module.exports = __webpack_public_path__ + "img/emerald.75b1a26d.svg";